<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="green lighten-2" dark v-bind="attrs" v-on="on" fab small>
          <v-icon>mdi-cards</v-icon>
        </v-btn>
      </template>

      <v-card dark>
        <v-card-title class="">
          Cartão fidelidade - Barbearia Lisboa
        </v-card-title>

        <v-card-text class="pa-5">
          Olá
          <h2 class="subtitle-1">
            <strong>{{ item.nome }}</strong
            >, <br />
            Email <strong>{{ item.email }}</strong
            >. <br />
            Você foi atendido
            <strong>{{ item.totalVisitas }}</strong> vezes.
          </h2>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: [ "item"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
